// extracted by mini-css-extract-plugin
export default {"root":"style_root__f-Bgi","selected":"style_selected__51EOJ"};